import Group from './Group.js';
import ReduxFormGroupAdapter from './ReduxFormGroupAdapter.js';

Group.ReduxForm = ReduxFormGroupAdapter;

export default Group;
export { ReduxFormGroupAdapter as ReduxForm };
